import React, {Component} from 'react';
import Table from './Table.js';
import Form from './Form.js';
import Api from './Api.js';

class App extends Component{
    
    state = {
      characters: [
        {
          name: "Chadwick Boseman",
          role: "Black Panther"
        },
        {
          name: "Gwyneth Paltrow",
          role: "Pepper Potts"
        },
        {
          name: "Don Cheadle",
          role: "War Machine"
        },
        {
          name: "Tilda Swinton",
          role: "The Ancient One"
        }        
      ]
    };

    removeCharacter = index => {
      const {characters} = this.state;

      this.setState({
        characters: characters.filter( (character, i) => {
          return i !== index;
        })
      });
    }

    handleSubmit = character => {
      this.setState({characters: [...this.state.characters, character]});
    }

    render(){
      const {characters} = this.state;  
      return(
        <div className="container">
          <Table characterData={characters} 
                 removeCharacter={this.removeCharacter}
          />
          <Form handleSubmit={this.handleSubmit}/>
          <Api/>
        </div>
      );
    }

  }

  export default App;